module.exports = __webpack_public_path__ + "img/heytrade-dark.2d5a5cf8.png";